module.exports = __webpack_public_path__ + "assets/img/more-btn-f8804a90.png";